import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  theme = signal(localStorage.getItem('tess-theme') ?? 'light');

  constructor() {
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches &&
      !localStorage.getItem('tess-theme')
    ) {
      this.theme.set('dark');
    }
  }

  toggle(): void {
    const theme = this.theme() === 'light' ? 'dark' : 'light';
    this.theme.set(theme);
    localStorage.setItem('tess-theme', theme);
  }
}
